export const phoneNumberRegex = /^(\+?\d{1,2}\s?)?(\(?\d{3}\)?[\s-]?)?\d{3}[\s-]?\d{4}$/;

export const normalizePhoneNumber = (phone?: string) => (phone || '').replace(/\D/g, '');

// Normalize live input for phone fields: digits only and capped to 15
export const normalizePhoneInput = (value: string) => (value || '').replace(/\D+/g, '').slice(0, 15);


